@if(loading) {
    <app-header></app-header>
    <app-navbar></app-navbar>
}
<!--
<a href="#" (click)="onLogin($event)">Conectate con la UOC!</a>
 @if(!this.userConected) 

}
<br />
<br />
<button (click)="validateTokenExpired()">Validar Token Expirado test</button>
-->